
var SharpnessShader = {
    uniforms: {
        "tDiffuse": { value: null },
        "resolution": { value: null },
        //"isWithGaussianBlur": {value: 1.0},
        "sharpness": { value: 9.0 },
        //"colorFactor": { value: 1 },
    },

    vertexShader: `
        varying vec2 vUv;

        void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
    `,

    fragmentShader:`
        uniform sampler2D tDiffuse;
        uniform float colorFactor;
        uniform vec2 resolution;
        uniform float sharpness;

        varying vec2 vUv;

        vec3 convoution(float[9] kernel) {
            vec3 result = vec3(0.0, 0.0, 0.0);
            int offset = 0;
            for (int r=-1; r < 2; r++) {
                for (int c=-1; c < 2; c++) {
                    result += kernel[offset]*vec3(texture2D(tDiffuse, vUv + (vec2(r, c) / resolution)));
                    offset = offset + 1;
                }
            }
            return clamp(result, 0.0, 1.0);
        }

        void main() {
            vec4 texel = texture2D(tDiffuse, vUv);
            float[9] sharpness_kernel = float[] (-1.0, -1.0, -1.0,
                                                 -1.0, sharpness, -1.0,
                                                 -1.0, -1.0, -1.0);

            gl_FragColor = vec4(convoution(sharpness_kernel), texel.a);
        }
    `,

};

export { SharpnessShader };

